// utils/trackingOrders/track.ts - utils/trackingOrders.ts split (sub-module track)

import { trackAnalyticsEvent } from '../trackingPixels';


function getUserIdentifier(customerPhone?: string, customerEmail?: string): string | null {
    return customerPhone || customerEmail || null;
}



export async function trackOrderCreated(orderId: string, formId: string, productId?: string, brandId?: string, customerPhone?: string, customerEmail?: string, customerName?: string, productName?: string, variant?: string, totalPrice?: number) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('order_created', 'order', userIdentifier, { orderId, formId, productId, brandId, eventData: { customerPhone, customerEmail, customerName, productName, variant, totalPrice } });
}



export async function trackOrderShipped(orderId: string, customerPhone?: string, customerEmail?: string, shippingMethod?: string, shippingResi?: string) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('order_shipped', 'shipping', userIdentifier, { orderId, eventData: { customerPhone, customerEmail, shippingMethod, shippingResi } });
}



export async function trackOrderDelivered(orderId: string, customerPhone?: string, customerEmail?: string, shippingMethod?: string) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('order_delivered', 'shipping', userIdentifier, { orderId, eventData: { customerPhone, customerEmail, shippingMethod, deliveredAt: new Date().toISOString() } });
}



export async function trackOrderRTS(orderId: string, customerPhone?: string, customerEmail?: string, reason?: string) {
    const userIdentifier = getUserIdentifier(customerPhone, customerEmail);
    await trackAnalyticsEvent('order_rts', 'shipping', userIdentifier, { orderId, eventData: { customerPhone, customerEmail, reason, rtsAt: new Date().toISOString() } });
}
